import { useMediaDeviceSelect } from '@livekit/components-react'
import { useCallback } from 'react'

import type { DeviceKind } from './DeviceMenu'

import { DeviceMenu } from './DeviceMenu'
import styles from './medentee.module.css'

export type ToolbarDeviceMenuProps = {
  kind: DeviceKind
}

export function ToolbarDeviceMenu({ kind }: ToolbarDeviceMenuProps) {
  const { devices, activeDeviceId, setActiveMediaDevice } = useMediaDeviceSelect({ kind })

  const handleSelect = useCallback(
    (deviceId: string) => {
      setActiveMediaDevice(deviceId, { exact: true }).catch(() => undefined)
    },
    [setActiveMediaDevice]
  )

  return (
    <div className={styles.deviceMenu}>
      <DeviceMenu
        kind={kind}
        devices={devices}
        activeDeviceId={activeDeviceId}
        disabled={!devices.length}
        triggerClassName={styles.deviceTrigger}
        onSelect={handleSelect}
      />
    </div>
  )
}
